import jwt_decode from 'jwt-decode'
import {ERROR,UPDATE_MESSAGE_SUPPRESSION,UPDATE_PROVIDER_TOKEN} from "./mutation-types";
import crypto from '@/common/resources/crypto.js'

export default {

  UPDATE_ACTIVITY_EVENTS(state, value){
    state.activityEvents = value;
  },

  UPDATE_OCI_ANALYTICS(state, value){
    state.ociAnalytics = value;
  },

  updateProjectUploadColumns(state, value) {
    state.projectUploadColumns = value;
  },
  FILE_SCANNING(state, value) {
    state.fileScanning = value;
  },
  PURCHASER_DETAILS(state, value) {
    state.purchaserDetails = value;
  },
  UPDATE_MOST_RECENT_CAMPAIGNS(state, campaigns) {
    state.mostRecentCampaignsStatus = campaigns;
  },

  UPDATE_LENDER_CRITERIA_RESULTS(state, lenderCriteriaResults) {
    state.lenderCriteriaResults = lenderCriteriaResults;
  },
  UPDATE_PROJECT_CODES(state, value) {
    // Refreshing from app level not including API
    // state.persons.push(newItem)
    state.projectCodes = value;
  },
  UPDATE_EVENTS_HISTORY(state,value){
    state.eventsByLoanId = value;
  },
  updateLenderAnalytics (state, value) {
    // mutate state
    state.lenderAnalytics = value;
  },
  updateLenderPage (state, value) {
    // mutate state
    state.lenderPage = value;
  },
  increment (state) {
    // mutate state
    state.count++
  },

  changeCount (state,value) {
    // mutate state
    state.count = value
  },
  UPDATE_EDS_FUNDING(state, value){
    state.edsFunding = value;
  },

  LOAD_PERSONS(state, items){
    state.persons = items
  },
  //incomplete in testing phase
  ADD_PERSON(state,newItem){
    // Refreshing from app level not including API
    // state.persons.push(newItem)
    state.person = newItem
  },
  ADD_PROJECT(state, newProject) {
    state.project = newProject
  },
  CLEAR_PROJECT(state) {
    state.project = {}
  },
  LOAD_FIRM_REPS_WITH_USER_INFO(state, firmRep) {
    state.firmRepsWithUserInfo = firmRep
  },
  LOAD_FIRM_REPS_UNDERWRITERS(state, firmRep){
    state.firmRepsWithUserInfo = firmRep
  },
  GET_FIRMREP(state, firmRep) {
    state.firmRep = firmRep
  },
  ADD_FIRMREP(state, firmRep) {
    state.firmRep = firmRep
  },
  UPDATE_FIRMREP(state, updatedFirmRep) {
    state.firmRep = updatedFirmRep
  },
  GET_ACTIVE_FIRM(state, activeFirm) {
    state.activeFirm = activeFirm
  },
  UPDATE_FIRM(state, updatedFirm) {
    state.firm = updatedFirm
  },
  GET_PROJECT(state, project) {
    state.project = project
  },
  GET_FIRM(state, firm) {
    state.firm = firm
  },
  GET_PERSON(state, item){
    state.person = item
  },
  GET_APPLICANT(state, item){
    state.applicant = item
  },
  UPDATE_APPLICANT(state, updatedItem) {
    state.applicant = updatedItem
  },
  UPDATE_APPLICATION_APPLICANT(state, updatedItem) {
    state.applicationApplicant = updatedItem
  },
  GET_SPOUSE(state, item){
    state.spouse = item
  },
  UPDATE_SPOUSE(state, updatedItem) {
    state.spouse = updatedItem
  },
  ADD_SPOUSE(state, newSpouse) {
    state.spouse = newSpouse
  },
  SET_ACTIVE_SPOUSE(state, spouse) {
    state.activeSpouse = spouse
  },
  UPDATE_CO_APPLICANT(state, updatedItem) {
    state.activeCoApplicant = updatedItem
  },
  SET_CO_APPLICANTS(state, coApplicants) {
    state.coApplicantArray = coApplicants
  },
  SET_ACTIVE_CO_APPLICANT(state, coApplicant) {
    state.activeCoApplicant = coApplicant
  },
  /*Used to create a state with the list of applicants to be updated*/
  UPDATE_SELECTED_APPLICANTS(state, updatedItems) {
    state.selectedApplicants = updatedItems
  },
  ADD_APPLICANT(state, newApplicant) {
    state.applicant = newApplicant
  },
  SET_ACTIVE_CLIENT(state, person) {
    state.activeClient = person
  },
  SET_ACTIVE_APPLICANT(state, applicant) {
    state.activeApplicant = applicant
  },
  SET_ACTIVE_FIRM(state, firm) {
    state.activeFirm = firm
  },
  UPDATE_PERSON(state, updatedItem){
    state.person = updatedItem
     },
  SET_LOADING(state, status){
    state.dataLoading = status;
  },
  SET_LOADED(state,status) {
    state.dataLoaded = status;
  },
  LOAD_FIRMS(state, firmsCollection) {
    state.firms = firmsCollection
  },
  LOAD_FIRMS_BY_TYPE(state, firms) {
    state.firmsByType = firms
  },
  SET_ENROLLMENT_PHASE(state,phase) {
    state.enrollmentPhase=phase;
  },
  //Applicants
  LOAD_APPLICANTS(state, applicantsCollection){
    state.applicants = applicantsCollection
  },

  LOAD_LENDERDATA(state, data){
    state.lenderClientDataData = data;
  },
  LOAD_CLIENTDATA(state, clientsDataCollection){
    state.clientsData = clientsDataCollection
  },
  LOAD_BROKER_PROJECTS(state, projectNames) {
    state.brokerProjects = projectNames
  },
  LOAD_PROJECTS(state, projectNames) {
    state.projects = projectNames
  },
  LOAD_MESSAGES(state, items){
    state.messages = items
  },
  LOAD_MESSAGE(state, items){
    state.message = items
  },
  LOAD_MESSAGE_BY_TYPE(state, newItem){
    //state.type = items
    state.msgTypeArray.push(newItem)
  },
  SET_ACTIVE_MESSAGE(state, items) {
    state.activeMessage = items
  },
  ADD_MESSAGE(state,newItem){
    state.message= newItem
  },
  UPDATE_MESSAGE(state, updatedMessage) {
    state.message = updatedMessage
  },
  LOAD_APPLICANT_BY_PROFILE_ID(state, items) {
    state.applicantByProfile = items
  },
  //Auth and Session
  UPDATE_SESSION_INFO(state, value) {
    state.sessionInfo = value
  },
  UPDATE_AUTH_RESPONSE(state, value) {
    state.authResponse = value
  },
  AUTH_SUCCESS: (state, userToken) => {
    state.userStatus = 'authenticated'
    state.userToken = userToken

  },
  AUTH_ERROR: (state) => {
    state.userStatus = 'error'
  },
  AUTH_LOGOUT: (state) => {
    sessionStorage.removeItem('ocu') // clear your user's token from sessionStorage
    state.appUser=null;
    state.userToken=null;
    state.userHome=null;
    state.userStatus = 'loggedout'
  },
  LOAD_APP_USER: (state,decodedToken) => {
    state.appUser = decodedToken
  },
  LOAD_PROJECT_ASSET_BY_APPLICANT(state, items) {
    state.projectAssetByApplicant = items
  },
  LOAD_PROJECT_ASSET(state, items) {
    state.projectAsset = items
  },
  LOAD_PROJECTS_BY_FIRM(state, items) {
    state.projectsByFirm = items
  },
  LOAD_ALL_PROJECTS(state, items) {
    state.projects = items;
  },
  UPDATE_CO_APPLICANT_ARRAY(state, items) {
    state.coApplicantArray = items
  },
  SET_USER_HOME: (state) => {

    //TODO Uncomment to use for PRODUCTION to get specific subdomain per firm
   // let  subdomain = state.appUser.firmDomain;
   //  if (subdomain === undefined || subdomain === null ){
   //    subdomain = '';
   //
   //  }

    let  subdomain = '';

    let roles = state.appUser.roles
   // this.ociLog(roles[0].role)
    var matched = false;
    for(let i=0; i<roles.length;i++){

      switch(roles[i].role) {
        case 'super':
          state.userHome = subdomain+'/broker/brokerpage';
          matched=true;
          break;
        case 'purchaser':
          state.userHome = 'purchaser/Accelerator';
          matched=true;
          break;
        case 'lender':
          state.userHome =subdomain+'/lender';
          matched=true;
          break;
        case 'developer':
          state.userHome =subdomain+'/developer';
          matched=true;
          break;
        case 'oci':
          state.userHome =subdomain+'/broker/brokerpage';
          matched=true;
          break;

      }
      if(matched===true){
        break;
      }
    }

  },
  FORCE_USER_HOME_PAGE:(state,homepage)=>{
    state.userHome=homepage;
  },
  LOAD_PURCHASE_PRICE_SUM: (state, sum) => {
    state.purchasePriceSum = sum;
  },
  LOAD_PROJECT_ASSET_PURCHASE_PRICE: (state, projectAssetPurchasePrice) => {
    state.projectAssetPurchasePrice = projectAssetPurchasePrice;
  },
  LOAD_PURCHASE_PRICE_SUM_AWARENESS: (state, sum) => {
    state.purchasePriceSumAwareness = sum;
  },
  LOAD_PURCHASE_PRICE_SUM_EXPLORATION: (state, sum) => {
    state.purchasePriceSumExploration = sum;
  },
  LOAD_PURCHASE_PRICE_SUM_APPROVAL: (state, sum) => {
    state.purchasePriceSumApproval = sum;
  },
  LOAD_DOCUMENTS(state, items){
    state.documents = items
  },
  LOAD_LENDER_RESPONSES(state, items){
    state.lenderResponses = items;
  },
  LOAD_LENDER_SUBMIT_RESPONSES(state, items){
    state.lenderSubmitResponses = items;
  },
  LOAD_LENDER_SUBMISSIONS(state, items){
    state.lenderSubmissions = items;
  },
  ACTIVE_APPLICATION_APPLICANT(state, appApplicant) {
    state.editableApplicationApplicant = appApplicant
    state.activeApplicationApplicant = appApplicant
  },
  ADD_APPLICATION_HISTORY(state, newHistory) {
    state.applicationHistory = newHistory;
  },
  ADD_APPLICATION_HISTORIES(state, historyList){
    state.applicationHistories = historyList;
  },
  UPDATE_APPLICATION_HISTORY(state, history) {
    state.applicationHistoryDetails = history;
  },
  GET_APPLICATION_STATUS(state, history) {
    state.applicationStatus = history;
  },
  LOAD_AVAILABLE_GROUP_ROLES: (state, roles) => {
    state.availableGroupRoles = roles;
  },
  UPDATEASSETVALUE: (state, value) => {
    state.assetValue = value;
  },
  UPDATECOAPPLICANTASSETS: (state, value) => {
    state.coApplicantAssets = value;
  },
  UPDATELIABILITIESVALUE: (state, value) => {
    state.liabilitiesValue = value;
  },
  UPDATEOTHERLIABILITES: (state, value) => {
    state.otherLiabilities = value;
  },

  UPDATEERROR: (state, value) => {
    state.error = value;
  },
  // Mutations ref to chats
  LOAD_PURCHASER_CHAT(state, chat){
    state.purchaserChat = chat;

  },
  LOAD_PURCHASER_CHAT_MESSAGES(state, chatMessages){
    state.purchaserChatMessages = chatMessages;
  },
  ADD_PURCHASER_CHAT_MESSAGE(state, chatMessage){
    if (state.purchaserChat.messages===null){
      state.purchaserChat.messages = [chatMessage];
    }
    else {
      state.purchaserChat.messages.push(chatMessage);
    }
    //state.purchaserChat.messages.push(chatMessage);
  } ,
  LOAD_PURCHASER_CHATS(state, chats){
    state.purchaserChats = chats;
  },
  ADD_CHAT_PURCHASER_CHATS(state, chat){
    if (state.purchaserChats.length<1){
      state.purchaserChats = [chat];
    }
    else {
      state.purchaserChats.push(chat);
    }
  },
  //TODO finish vuex implementation and backend to load all chats -- generic, any party, for future enhancement
  LOAD_USER_CHATS(state, chats){
    state.userChats = chats;
  },
  LOAD_CURRENT_CHAT_MESSAGES(state, currentChatMessages){
    state.currentChatMessages = currentChatMessages;
  },
  ADD_CURRENT_CHAT_MESSAGE(state, currentChatMessage){
    state.currentChatMessages.push(currentChatMessage);
  },
  // ADD_MESSAGE_TO_CHAT(state, currentChatMessage){
  //   let chats = state.purchaserChats;
  //   let matchedChat = chats.find( item =>item.)
  //
  //   state.currentChatMessages.push(currentChatMessage);
  // },

LOAD_CURRENT_NOTIFICATIONS (state, notifications){
  state.currentNotifications = notifications;
},
  //Notification from Stomp connection.
   ADD_RECENT_NOTIFICATION(state, notification) {

      let match = false;
    for (let i= 0;i<state.currentNotifications.length; i++){
      if (state.currentNotifications[i].messageId == notification.messageId){
        match= true;
         break;
      }
    }
      if (match===false){
        if (state.currentNotifications.length<1) {

          state.currentNotifications = [notification];
        }
        else {

          state.currentNotifications.push(notification);
        }
      }
   },

  SET_NOTIFICATION_HISTORY_DISPLAY (state, value){
    state.notificationHistoryDisplay = value;
  },
  UPDATE_BROKER_CHAT_PAGE_OPEN (state, value){
    state.brokerChatPageOpen= value;
  },
  UPDATE_BROKER_MINI_CHAT_OPEN (state, value){
    state.brokerMiniChatOpen= value;
  },
  UPDATE_MONTHLY_RENT (state, value){
    state.monthlyRent= value;
  },
  UPDATE_OCCUPANCY_TYPE (state, value){
    state.occupancy= value;
  },
  UPDATE_RECENT_APPLICATIONS(state, recentApps) {
    localStorage.setItem('a', crypto.encryptParam(String(JSON.stringify(recentApps))));
    state.recentApplications = (recentApps)
  },
   ALL_APPLICATION_APPLICANTS(state, items) {
  state.allApplicationApplicantsInitial=(items)
  state.allApplicationApplicants = (items)
  },
  UPDATE_ALL_APPLICATION_APPLICANTS(state, updatedItem) {
    state.allApplicationApplicants = updatedItem
  },
  ADD_NEW_APPLICATION_APPLICANT(state, updatedItem){
    state.allApplicationApplicants = updatedItem
  },
  showSideBar(state, value) {
    state.showSideBar = value;
  },
  // ActiveApplicationApplicant Mutations

  UPDATE_ACTIVE_APPLICANT(state, applicant) {
      state.activeApplicationApplicant.applicant = applicant
  },
  //UPDATING Application Applicant Mutations
  UPDATE_APPLICATION_APPLICANT_IN_ARRAY(state, data) {
    state.allApplicationApplicants[data.index] = data.appApplicant
  },
  UPDATE_APPLICANT_IN_ARRAY(state, data) {
    state.allApplicationApplicants[data.index].applicant = data.applicant
  },

  //Data Loading Status
  UPDATE_APPLICATION_APPLICANT_LOADING (state, status) {
    state.activeApplicationApplicantLoading = status
  },
  UPDATE_ALL_APPLICATION_APPLICANT_LOADING (state, status) {
    state.allApplicationApplicantsLoading = status
  },
  UPLOADED_FILE_URL(state, url){
    state.uploadedFileURL = url
  },
  UPDATE_PERSON_PROFILE_LOADING (state, status) {
    state.personProfileLoading = status
  },

  setPagination(state, value) {
    state.pagination = value;
  },
  setProspectorClientsData(state, value) {
    state.prospectorClientsData = value;
  },
  setSelectedProject(state, value) {
    state.selectedProject = value;
  },
  setProjectUploadDataLoading(state, value) {
    state.projectUploadDataLoading = value;
  },
  setProgramPerformance(state, value) {
    state.projectPerformance = value;
  },
  setShowApplicant(state, value) {
    if(state.showApplicant.length -1 >= value.index){
      state.showApplicant[value.index].show = value.show;
    }
    else {
      state.showApplicant.push(value);
    }
  },
  APPLICANTS_COUNT(state, value) {
    state.applicantsCount = value;
  },
  NEW_APPLICANTS(state, value) {
    state.newApplicants = value;
  },
  FIND_APPLICANTS(state, value) {
    state.findApplicants = value;
  },
  LOAN_APPLICATION_NEW_APPLICANTS(state, value) {
    state.loanApplicationNewApplicants = value;
  },
  UPDATE_BUREAU (state, bureauData) {
    for(let i=0;i<state.allApplicationApplicants.length;i++){
      for (let j=0;j<bureauData.creditBureaus.length;j++)
        if (state.allApplicationApplicants[i].applicant.applicantId===bureauData.ociApplicantId){
          state.allApplicationApplicants[i].applicant.creditBureaus.push(bureauData.creditBureaus[j]);
          state.creditBureauMatchIndicator=bureauData.creditBureaus[j].matchIndicator;
          break;
        }
    }
    state.bureauRequestedRetrieved = true;
  },
  UPDATE_EXISTING_BUREAU (state, bureauData) {
    for(let i=0;i<state.allApplicationApplicants.length;i++){
      for (let j=0;j<bureauData.creditBureaus.length;j++)
        if (state.allApplicationApplicants[i].applicant.applicantId===bureauData.ociApplicantId){
        for(let k=0;k<state.allApplicationApplicants[i].applicant.creditBureaus.length;k++){
          if(state.allApplicationApplicants[i].applicant.creditBureaus[k].creditBureauId === bureauData.creditBureaus[j].creditBureauId){
            state.allApplicationApplicants[i].applicant.creditBureaus.splice(k,1)
            break;
          }
        }
          state.allApplicationApplicants[i].applicant.creditBureaus.push(bureauData.creditBureaus[j]);
          state.creditBureauMatchIndicator=bureauData.creditBureaus[j].matchIndicator;
        }
    }
    state.bureauRequestedRetrieved = true;
  },
  UPDATE_REQUESTED_BUREAU_RETRIEVED (state, bureauRetrievedStatus) {
    state.bureauRequestedRetrieved = bureauRetrievedStatus
  },
  UPDATE_CREDIT_BUREAU_MATCH (state, matchIndicator) {
    state.creditBureauMatchIndicator = matchIndicator
  },
  UPDATE_MORTGAGE_APP_REFRESH (state, refreStatus) {
    state.mortgageApplicationRefresh = refreStatus
  },
  UPDATE_APP_APPLICANT_HISTORY (state, appApplicantHistory) {
    state.appApplicantHistory = appApplicantHistory
  },
  UPDATE_APP_APPLICANT_HISTORY_LOADING(state, status) {
    state.appApplicantHistoryLoading = status
  },

  UPDATE_APP_APPLICANT_HISTORY_CONSENT(state, status) {
    state.appApplicantConsentStatus= status
  },
    UPDATE_OCI_APP_MESSAGE(state, status) {
  state.ociAppMessage= status
  },
  UPDATE_PDF_FILENAME(state, status) {
    state.pdfFileName = status
  },
  SEND_MARKETING_EMAIL(state, email){
    state.sendMarketingEmail = email;
  },
  GET_CAMPAIGNS(state, items){
    state.campaigns = items
  },
  // this is access control related.  simplify getting roles for vue-kindergarten
  SET_USER_ROLES: (state) => {
    let roles = state.appUser.roles
    for(let i=0; i<roles.length;i++){
      switch(roles[i].role) {
        case 'user':
          state.appUser.isUser = true;
          state.appUser.isUserGroup = true;
          break;
        case 'super':
          state.appUser.isSuper = true;
          state.appUser.isSuperGroup = true;
          break;
        case 'purchaser':
          state.appUser.isPurchaser = true;
          state.appUser.isPurchaserGroup = true;
          break;
        case 'client':
          state.appUser.isClient = true;
          state.appUser.isPurchaserGroup = true;
          break;
        case 'applicant':
          state.appUser.isApplicant = true;
          state.appUser.isPurchaserGroup = true;
          break;
        case 'lender':
          state.appUser.isLender = true;
          state.appUser.isLenderGroup = true;
          break;
        case 'lender_admin':
          state.appUser.isLenderAdmin = true;
          state.appUser.isLenderGroup = true;
          break;
        case 'lender_rep':
          state.appUser.isLenderRep = true;
          state.appUser.isLenderGroup = true;
          break;
        case 'lender_manager':
          state.appUser.isLenderManager = true;
          state.appUser.isLenderGroup = true;
          break;
        case 'developer':
          state.appUser.isDeveloper = true;
          state.appUser.isDeveloperGroup = true;
          break;
        case 'developer_rep':
          state.appUser.isDeveloperRep = true;
          state.appUser.isDeveloperGroup = true;
          break;
        case 'developer_admin':
          state.appUser.isDeveloperAdmin = true;
          state.appUser.isDeveloperGroup = true;
          break;
        case 'developer_manager':
          state.appUser.isDeveloperManager = true;
          state.appUser.isDeveloperGroup = true;
          break;
        case 'developer_marketer':
          state.appUser.isDeveloperMarketer = true;
          state.appUser.isDeveloperGroup = true;
          break;
        case 'oci':
          state.appUser.isOci = true;
          state.appUser.isOciGroup = true;
          break;
        case 'oci_broker':
          state.appUser.isOciBroker = true;
          state.appUser.isOciGroup = true;
          break;
        case 'oci_broker_manager':
          state.appUser.isOciBrokerManager = true;
          state.appUser.isOciGroup = true;
          break;
        case 'oci_admin':
          state.appUser.isOciAdmin = true;
          state.appUser.isOciGroup = true;
          break;
        case 'oci_developer':
          state.appUser.isOciDeveloper = true;
          state.appUser.isOciGroup = true;
          break;
        case 'oci_lender_transmitter':
          state.appUser.isOciLenderTransmitter = true;
          state.appUser.isOciGroup = true;
          break;
        case 'oci_credit_requester':
          state.appUser.isOciCreditRequester = true;
          state.appUser.isOciGroup = true;
          break;
        case 'system':
          state.appUser.isSystem = true;
          break;
        case 'partner':
          state.appUser.isPartner = true;
          state.appUser.isPartnerGroup = true;
          break;
        case 'partner_founder':
          state.appUser.isPartnerFounder = true;
          state.appUser.isPartnerGroup = true;
          break;
        case 'partner_investor':
          state.appUser.isPartnerInvestor = true;
          state.appUser.isPartnerGroup = true;
          break;
        case 'oci_finance':
          state.appUser.isOciFinance = true;
          state.appUser.isOciGroup = true;
          break;
        case 'oci_finance_director':
          state.appUser.isOciFinanceDirector = true;
          state.appUser.isOciGroup = true;
          break;
      }
    }
  },
  [ERROR](state, error) {
    state.error = error
    // state.success = false
  },
  [UPDATE_MESSAGE_SUPPRESSION](state,status) {
    state.suppressGlobalErrorMessage=status;
  },
  withinMortgageApp: (state, value) => {
    state.withinMortgageApp = value;
  },
  PROMPT_MTG_APP_SAVE:(state, value) => {
    state.promptMtgAppSave = value;
  }
  ,

  saveStatus: (state, value) => {
    state.saveStatus = value;
  },
  projectName: (state, value) => {
    state.projectName = value;
  },
  UPDATE_PURCHASER_CONSENT(state,booleanVal){
    state.purchaserConsentUpdated=booleanVal;
  },
  ADDEDITEDCLIENTSDATA(state, value) {
    state.editedClientsData = value;
  },
  RESTRICTED_EMAIL_ADDRESSES(state, updatedItem) {
    state.restrictedEmailAddress = updatedItem
  },
  MARKETING_CLIENTDATA(state, value){
    state.marketingClientData = value;
  },
  [UPDATE_PROVIDER_TOKEN](state, value){
    state.providerToken = value;
  },
  UPDATE_ADDITIONAL_INTEREST_DETAILS(state, details) {
    state.additionalFinancialServiceInterestDetails = details
  },
  UPDATE_APP_APPLICANT_HISTORY_BY_LOAN_APPLICATION (state, appApplicantHistoryByLoanApplication) {
    state.appApplicantHistoryByLoanApplication = appApplicantHistoryByLoanApplication
  },
  GET_WEALTHSAVER_AMOUNT(state, wealthSaverAmount) {
    state.wealthSaverAmount = wealthSaverAmount
  },
  UPDATE_EMPLOYMENTS_IN_ARRAY(state, data) {
    state.allApplicationApplicants[data.index].applicant.employments = data.employments
  },
  UPDATE_ADDRESSES_IN_ARRAY(state, data) {
    state.allApplicationApplicants[data.index].applicant.personProfile.addresses = data.addresses
  },
  LOAD_PROFILE_BY_USER_ID(state, items) {
    state.profileByUser = items
  },
  SEND_BROKER_EMAIL_NOTIFICATION(state, email){
    state.sendBrokerEmailNotification = email;

  },
  UPDATE_APPLICANT_SEARCH_LOADING(state, value) {
    state.applicantSearchLoading = value
  },
  UPDATE_APPLICANT_CONSENT_LOADING(state, value) {
    state.applicantConsentLoading = value
  },
  GET_ACTIVE_CAMPAIGN(state, value) {
  state.activeCampaign = value
  },
  ADD_CAMPAIGN(state,newItem){
    state.campaign= newItem
  },
  UPDATE_PURCHASER_FLOW_CAMPAIGN(state,flow){
    state.activeCampaign.purchaserFlow= flow
  },
  GET_CAMPAIGNS_BY_PROJECT(state,newItem){
    state.campaignsByProject= newItem
  },
  GET_CAMPAIGNS_BY_FIRM(state,newItem){
  state.campaignsByFirm= newItem
  },
  LOAD_LENDER_CRITERIA_FILTERS(state,filter){
    state.lendingCriteriaFilters= filter
  },
  GET_BORROWERS_DISCLOSURE_FORM_DATA(state, value){
    state.borrowersDisclosureFormData = value
  },
  UPDATE_BORROWERS_DISCLOSURE_FORM_DATA_STATE(state, value){
    state.borrowersDisclosureFormData = value
  },
  UPDATE_CREDITOR_INSURANCE_REQUESTS(state, items){
    state.creditorInsuranceRequests = items
  },
  UPDATE_CREDITOR_INSURANCE_LOADING(state, value){
    state.creditorInsuranceLoading = value
  },
  GET_CONDITION_SET(state,newItem){
    state.conditionSet = newItem
  },
  ADD_CONDITION(state,newItem){
    state.condition= newItem
  },
  ADD_CONDITION_SET(state,newItem){
    state.conditionSet= newItem
  },
  GET_ACTIVE_CONDITION(state,newItem){
  state.activeCondition= newItem
  },
  GET_CONDITIONS(state,newItem){
  state.conditions = newItem
  },
  GET_APPLICATION_CONDITIONS(state,newItem){
  state.applicationConditions = newItem
  },
  ADD_APPLICATION_CONDITION_DETAILS(state,newItem){
  state.applicationConditions= newItem
  },
  GET_APPLICATION_CONDITION_SET(state,newItem){
  state.applicationConditionSet= newItem
  },
  UPDATE_APPLICATION_CONDITION_LOADING(state, status) {
  state.applicationConditionsLoading = status
  },
  CONDITIONS_BY_FIRM_TYPE(state, status) {
  state.conditionsByFirmType = status
  },
  SEND_PURCHASER_CONDITIONS(state, conditions) {
    state.sendPurchaserConditions = conditions
  },
  ADD_APPLICATION_CONDITION(state,newItem){
    state.applicationConditions= newItem
  },
  GET_DOCUMENT_STATUSES(state,newItem){
  state.documentStatus= newItem
  },
  LOAD_PROFILE_PICTURE(state, items) {
    state.profilePicture = items
  },
  UPDATE_CAMPAIGNS_LOADING(state, status) {
    state.campaignsLoading = status
  },
  GET_PROJECTS_BY_PROFILE(state, project) {
    state.projectsByProfile = project
  },
  GET_APPLICATION_STATUS_BY_APPLICATION_APPLICANT(state, status) {
    state.applicationStatusByAppApplicant = status
  },
  GET_PURCHASER_APPLICATION_CONDITIONS(state, status) {
    state.purchaserApplicationConditions = status
  },
  UPDATE_CONDITION_LOADING(state, status) {
    state.conditionsLoading = status
  },
  GET_RESTRICTED_EMAIL_ADDRESS(state, updatedItem) {
    state.restrictedEmailAddress = updatedItem
  },
  GET_LOAN_APPLICATIONS_BY_PROJECT(state, value){
    state.loanApplicationsByProject = value;
  },
  GET_INVOICING_FORM_DATA(state, value){
    state.invoiceFormData = value
  },
  GET_INVOICING_BY_FIRM_DATA(state, value){
    state.invoiceFormData = value
  },
  UPDATE_INVOICING_FORM_DATA_STATE(state, value){
    state.invoiceFormData = value
  },
  GET_SEARCHED_INVOICES(state, value){
    state.invoiceList = value
  },
  GET_GENERATED_INVOICES(state, value){
    state.generatedInvoices = value
  },
  GET_INVOICING_BY_ID(state, value){
    state.invoicing = value
  },
  GET_FIRM_REP_EMAIL(state, value){
    state.firmRepEmail = value
  },

  ADD_PURCHASER_ACTIVITY(state, item) {
    state.purchaserActivity.push(item)
  },
  RESET_PURCHASER_ACTIVITY(state) {
    state.purchaserActivity.length=0;
  },
  UPDATE_PURCHASER_FLOW(state,value){
    state.purchaserFlow = value;
  },
  UPDATE_PURCHASER_FLOWS(state,value){
    if(value.length>0){
      state.purchaserFlows = value;
    }
  },
  UPDATE_PURCHASER_DATA(state,value){
    state.purchaserData = value;
  }

}
